module.exports = __webpack_public_path__ + "img/story047@2x.fdcf3973.webp";